module.exports = __webpack_public_path__ + "static/media/logo-white.b727cb2b.png";